import { ModuleFE_AppConfig } from './ModuleFE_AppConfig.js';
export const ModulePackFE_AppConfigDB = [ModuleFE_AppConfig];
//# sourceMappingURL=module-pack.js.map